<template>
  <!-- <b-card class="sales-pipeline" v-if="hasRight(user, 'dashboard', 'view')" no-body>
    <template #header>
      <h6 class="mb-0">SALES PIPELINE</h6>
    </template>
    <b-card-body> -->
      <b-row>
        <b-col cols="12" sm="6" md="3">
          <sales-progress-card
            title="Prospects Received"
            :value="pipelineData.prospects_received.count"
            :progressPercentage="pipelineData.prospects_received.progress_percentage"
            color="blue darken-2"
            clickable
            @click.native="$emit('sales-card-click', 'prospects_received')"
          />
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <sales-progress-card
            title="Site Visit Done"
            :value="pipelineData.site_visit_done.count"
            :progressPercentage="pipelineData.site_visit_done.progress_percentage"
            color="cyan darken-2"
            clickable
            @click.native="$emit('sales-card-click', 'site_visit_done')"
          />
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <sales-progress-card
            title="Closure Meeting"
            :value="pipelineData.closure_meeting.count"
            :progressPercentage="pipelineData.closure_meeting.progress_percentage"
            color="light-green darken-2"
            clickable
            @click.native="$emit('sales-card-click', 'closure_meeting')"
          />
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <sales-progress-card
            title="Negotiation"
            :value="pipelineData.negotiation.count"
            :progressPercentage="pipelineData.negotiation.progress_percentage"
            color="orange darken-2"
            clickable
            @click.native="$emit('sales-card-click', 'negotiation')"
          />
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <sales-progress-card
            title="Final Closure (Retail)"
            :value="pipelineData.final_closure_retail.count"
            :progressPercentage="pipelineData.final_closure_retail.progress_percentage"
            color="red darken-2"
            clickable
            @click.native="$emit('sales-card-click', 'final_closure_retail')"
          />
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <sales-progress-card
            title="Final Closure (Bulk)"
            :value="pipelineData.final_closure_bulk.count"
            :progressPercentage="pipelineData.final_closure_bulk.progress_percentage"
            color="red darken-4"
            clickable
            @click.native="$emit('sales-card-click', 'final_closure_bulk')"
          />
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <sales-progress-card
            title="Total Closures"
            :value="pipelineData.total_closures.count"
            :progressPercentage="pipelineData.total_closures.progress_percentage"
            color="light-blue darken-2"
            clickable
            @click.native="$emit('sales-card-click', 'total_closures')"
          />
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <sales-progress-card
            title="Closure Value"
            :value="`₹ ${pipelineData.closure_value.value}`"
            :progressPercentage="pipelineData.closure_value.progress_percentage"
            color="teal darken-2"
            clickable
            @click.native="$emit('sales-card-click', 'closure_value')"
          />
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <sales-progress-card
            title="Total Bookings Done"
            :value="pipelineData.total_bookings_done.count"
            color="amber darken-2"
            clickable
            @click.native="$emit('sales-card-click', 'total_bookings_done')"
          />
        </b-col>
        <b-col cols="12" sm="6" md="3">
          <sales-progress-card
            title="Booking Value"
            :value="`₹ ${pipelineData.booking_value.value}`"
            color="deep-orange darken-2"
            clickable
            @click.native="$emit('sales-card-click', 'booking_value')"
          />
        </b-col>
      </b-row>
    <!-- </b-card-body>
  </b-card> -->
</template>
</template>

<script>
import SalesProgressCard from './SalesProgressCard.vue';
import { BRow, BCol, BCard, BCardBody } from 'bootstrap-vue';
import { hasRight } from '@/utils/auth';
import { dashboardGet } from './dashboardApi';

export default {
  name: 'SalesPipeline',
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    SalesProgressCard,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      default: null,
    },
    dashboardData: { type: Object, default: null },
    useAggregate: { type: Boolean, default: false },
    baseApi: {
      type: String,
      default: () => process.env.VUE_APP_APIENDPOINT || '',
    },
    accessToken: {
      type: String,
      default: () => localStorage.getItem('accessToken') || '',
    },
  },
  data() {
    return {
      pipelineData: {
        prospects_received: { count: 0, progress_percentage: null },
        site_visit_done: { count: 0, progress_percentage: null },
        closure_meeting: { count: 0, progress_percentage: null },
        negotiation: { count: 0, progress_percentage: null },
        final_closure_retail: { count: 0, progress_percentage: null },
        final_closure_bulk: { count: 0, progress_percentage: null },
        total_closures: { count: 0, progress_percentage: null },
        closure_value: { value: 0, progress_percentage: null },
        total_bookings_done: { count: 0 },
        booking_value: { value: 0 },
      },
    };
  },
  watch: {
    dashboardData: { deep: true, handler(v) { if (v && v.sales_pipeline != null && hasRight(this.user, 'dashboard', 'view')) this.pipelineData = { ...this.pipelineData, ...v.sales_pipeline }; } },
    filters: {
      deep: true,
      immediate: true,
      handler() {
        if (!hasRight(this.user, 'dashboard', 'view')) return;
        if (this.useAggregate) {
          if (this.dashboardData && this.dashboardData.sales_pipeline != null) this.pipelineData = { ...this.pipelineData, ...this.dashboardData.sales_pipeline };
          return;
        }
        if (this.dashboardData && this.dashboardData.sales_pipeline != null) { this.pipelineData = { ...this.pipelineData, ...this.dashboardData.sales_pipeline }; return; }
        this.fetchSalesPipelineData();
      },
    },
    user: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (hasRight(newVal, 'dashboard', 'view')) {
          if (this.useAggregate) {
            if (this.dashboardData && this.dashboardData.sales_pipeline != null) this.pipelineData = this.dashboardData.sales_pipeline;
            return;
          }
          this.fetchSalesPipelineData();
        } else {
          this.pipelineData = {
            prospects_received: { count: 0, progress_percentage: null },
            site_visit_done: { count: 0, progress_percentage: null },
            closure_meeting: { count: 0, progress_percentage: null },
            negotiation: { count: 0, progress_percentage: null },
            final_closure_retail: { count: 0, progress_percentage: null },
            final_closure_bulk: { count: 0, progress_percentage: null },
            total_closures: { count: 0, progress_percentage: null },
            closure_value: { value: 0, progress_percentage: null },
            total_bookings_done: { count: 0 },
            booking_value: { value: 0 },
          };
        }
      },
    },
  },
  methods: {
    hasRight, // Make the helper available in the template
    async fetchSalesPipelineData() {
      if (!hasRight(this.user, 'dashboard', 'view')) return;
      if (this.useAggregate || (this.dashboardData && this.dashboardData.sales_pipeline != null)) {
        if (this.dashboardData && this.dashboardData.sales_pipeline != null) this.pipelineData = this.dashboardData.sales_pipeline;
        return;
      }
      try {
        const response = await dashboardGet(this.baseApi, this.accessToken, '/dashboard/crm/sales-pipeline', this.filters);
        this.pipelineData = response.data.data;
      } catch (error) {
        console.error('Error fetching sales pipeline data:', error);
        // Handle error
      }
    },
  },
};
</script>

<style scoped>
.sales-pipeline {
  margin-top: 20px;
}
</style>